import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import SVG from "../../../Components/SVG";
import { useEffect, useState } from "react";

export default function Missions({ accountData }) {
  const [targetStatus, setTargetStatus] = useState("stable");
  const [totalDrawdownStatus, setTotalDrawdownStatus] = useState("stable");
  const [dailyDrawdownStatus, setDailyDrawdownStatus] = useState("stable");
  const [tradeDrawdownStatus, setTradeDrawdownStatus] = useState("stable");
  const [minTradingDaysStatus, setMinTradingDaysStatus] = useState("stable");
  const [consRuleStatus, setConsRuleStatus] = useState("stable");
  const [scalpProfitStatus, setScalpProfitStatus] = useState("stable");

  useEffect(() => {
    console.log("Account Data in Missions:", accountData);
    if (accountData !== null && accountData !== undefined) {
      // Example logic to determine target status based on accountData
      if (accountData.status === "live") {
        if (
          accountData.rules.profit_target.current_state >=
          accountData.rules.profit_target.definition
        ) {
          setTargetStatus("passed");
        } else if (
          accountData.rules.profit_target.current_state <
            accountData.rules.profit_target.definition &&
          accountData.rules.profit_target.current_state >= 0
        ) {
          setTargetStatus("stable");
        } else {
          setTargetStatus("danger");
        }

        if (accountData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (accountData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (accountData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(accountData.trading_days) >=
          Number(accountData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("danger");
        }
        if (accountData.rules.consistency_rule.violated) {
          setConsRuleStatus("danger");
        } else {
          setConsRuleStatus("stable");
        }
        if (accountData.rules.fast_scalp.violated) {
          setScalpProfitStatus("danger");
        } else {
          setScalpProfitStatus("stable");
        }
      } else {
        if (
          accountData.rules.profit_target.current_state >=
          accountData.rules.profit_target.definition
        ) {
          setTargetStatus("passed");
        } else {
          setTargetStatus("stable");
        }

        if (accountData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (accountData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (accountData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(accountData.trading_days) >=
          Number(accountData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("failed");
        }
        if (accountData.rules.consistency_rule.violated) {
          setConsRuleStatus("failed");
        } else {
          setConsRuleStatus("passed");
        }
        if (accountData.rules.fast_scalp.violated) {
          setScalpProfitStatus("failed");
        } else {
          setScalpProfitStatus("passed");
        }
      }
    }
  }, [accountData]);
  return (
    <div className="w-full h-fit flex flex-col p-5 gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      <div className="w-full flex justify-between items-center">
        <h2 className="flex gap-2.5 items-center">
          <SVG
            name="mission"
            classname="size-5 stroke-zi-blue-dark dark:stroke-white"
          />
          <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            مأموریت‌های چالش
          </span>
        </h2>
      </div>

      <Table
        columns={[
          { key: "title", label: "عنوان" },
          { key: "current", label: "وضعیت فعلی" },
          { key: "metric", label: "معیار" },
          {
            key: "status",
            label: "وضعیت",
            render: (value) =>
              value === "passed" ? (
                <StatusColorful
                  SVGName="tick"
                  text="تکمیل شده"
                  className="w-24"
                  color="blue"
                />
              ) : value === "stable" ? (
                <StatusColorful
                  SVGName="stall"
                  text="پایدار"
                  className="w-24"
                  color="green"
                />
              ) : value === "danger" ? (
                <StatusColorful
                  SVGName="danger"
                  text="ناپایدار"
                  className="w-24"
                  color="yellow"
                />
              ) : value === "failed" ? (
                <StatusColorful
                  SVGName="failed"
                  text="رد شده"
                  className="w-24"
                  color="red"
                />
              ) : (
                ""
              ),
          },
        ]}
        data={[
          {
            title: "سود هدف",
            current:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.profit_target?.current_state
                    ).toFixed(2) || "-"
                  } درصد`
                : "۰ درصد",
            metric:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.profit_target?.definition
                    ).toFixed(2) || "-"
                  } درصد`
                : "۵ درصد",
            status: targetStatus,
          },
          {
            title: "حد ضرر کلی",
            current:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.max_drawdown_limit?.current_state
                    ).toFixed(2) || "-"
                  } درصد`
                : "۰ درصد",
            metric:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.max_drawdown_limit?.definition
                    ).toFixed(2) || "-"
                  } درصد`
                : "۵ درصد",
            status: totalDrawdownStatus,
          },
          {
            title: "حد ضرر روزانه",
            current:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.daily_drawdown_limit?.current_state
                    ).toFixed(2) || "-"
                  } درصد`
                : "۰ درصد",
            metric:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.daily_drawdown_limit?.definition
                    ).toFixed(2) || "-"
                  } درصد`
                : "۵ درصد",
            status: dailyDrawdownStatus,
          },
          {
            title: "حد ضرر هر معامله",
            current:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.trade_drawdown_limit?.current_state
                    ).toFixed(2) || "-"
                  } درصد`
                : "۰ درصد",
            metric:
              accountData != null
                ? `${
                    Number(
                      accountData?.rules?.trade_drawdown_limit?.definition
                    ).toFixed(2) || "-"
                  } درصد`
                : "۵ درصد",
            status: tradeDrawdownStatus,
          },
          {
            title: "حداقل روزهای معاملاتی",
            current:
              accountData != null ? `${accountData.trading_days} روز` : "۰ روز",
            metric:
              accountData != null
                ? `${accountData.min_trading_days} روز`
                : "۰ روز",
            status: minTradingDaysStatus,
          },

          // ✅ Consistency rule – only if definition != null
          ...(accountData?.rules?.consistency_rule?.definition != null
            ? [
                {
                  title: "حداکثر سود هر معامله از سود کل",
                  current: `${
                    Number(
                      accountData?.rules?.consistency_rule?.current_state
                    ).toFixed(2) || "-"
                  } درصد`,
                  metric: `${
                    Number(
                      accountData?.rules?.consistency_rule?.definition
                    ).toFixed(2) || "-"
                  } درصد`,
                  status: consRuleStatus,
                },
              ]
            : []),

          // ✅ Fast scalp – only if definition != null
          ...(accountData?.rules?.fast_scalp?.definition != null
            ? [
                {
                  title: "مجموع سود مجاز معاملات اسکلپ",
                  current: `${
                    Number(
                      accountData?.rules?.fast_scalp?.current_state
                    ).toFixed(2) || "-"
                  } درصد`,
                  metric: `${
                    Number(accountData?.rules?.fast_scalp?.definition).toFixed(
                      2
                    ) || "-"
                  } درصد`,
                  status: scalpProfitStatus,
                },
              ]
            : []),
        ]}
      />
    </div>
  );
}
